module.exports = __webpack_public_path__ + "static/media/CainIjegun3Girls.f9ab0982.JPG";